;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"86b99860ac39d9e683a75972647b50f511cbfb24"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

Sentry.init({
  environment: publicRuntimeConfig.stage,
  dsn: publicRuntimeConfig.sentryDsnFe,
  tracesSampleRate: 1.0,
});
